/**
 * @generated SignedSource<<9a93aed7ead7b9d6ded0f39906f3c47a>>
 * @relayHash 8c63d7bc7fa45a100e638518cca6dbed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88425252bf81ea78e2669a1c9bf81827b8511256219d0154cd93e0a742613ab0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAddIssuesToFixVersionInput = {
  issueIds: ReadonlyArray<string>;
  versionId: string;
};
export type useAddIssuesToVersionMutation$variables = {
  boardId: string;
  input: JiraAddIssuesToFixVersionInput;
};
export type useAddIssuesToVersionMutation$data = {
  readonly jira: {
    readonly addIssuesToFixVersion: {
      readonly success: boolean;
      readonly version: {
        readonly " $fragmentSpreads": FragmentRefs<"versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useAddIssuesToVersionMutation = {
  response: useAddIssuesToVersionMutation$data;
  variables: useAddIssuesToVersionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAddIssuesToVersionMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraAddIssuesToFixVersionPayload",
            "kind": "LinkedField",
            "name": "addIssuesToFixVersion",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAddIssuesToVersionMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraAddIssuesToFixVersionPayload",
            "kind": "LinkedField",
            "name": "addIssuesToFixVersion",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "versionId"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "releaseDate"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                      }
                    ],
                    "concreteType": "JiraVersionStatistics",
                    "kind": "LinkedField",
                    "name": "statistics",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "doneEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "percentageCompleted"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "notEstimated"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "done"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalIssueCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "toDo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "inProgress"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v5/*: any*/),
                      {
                        "alias": "editProjectConfig",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canPerform"
                          }
                        ],
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "88425252bf81ea78e2669a1c9bf81827b8511256219d0154cd93e0a742613ab0",
    "metadata": {},
    "name": "useAddIssuesToVersionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "78cd3b934e90c86f1f62037be8c3d343";

export default node;
